import { render, staticRenderFns } from "./ProductGroup.vue?vue&type=template&id=007ccca5&scoped=true&"
import script from "./ProductGroup.vue?vue&type=script&lang=js&"
export * from "./ProductGroup.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroup.vue?vue&type=style&index=0&id=007ccca5&scoped=true&lang=css&"
import style1 from "./ProductGroup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007ccca5",
  null
  
)

export default component.exports